export default __webpack_public_path__ + "static/media/2.a31eaf7d.jpg";